export default __webpack_public_path__ + "static/1_32-3f4552eb287768d817b0e240e9d6cdcc.png";